export const commonStatus = [
  {id: false, msg: "已禁用", color: "color-danger"},
  {id: true, msg: "已启用", color: "color-success"},
];

export const releaseDisplay = [
  {id: false, msg: "否", color: "color-disable"},
  {id: true, msg: "是"},
];

export const appApply = [
  {id: 0, msg: "设备端"},
  {id: 1, msg: "平台端"},
  {id: 2, msg: "通用"},
];

export const appPeriod = [
  {id: "day", msg: "天"},
  {id: "week", msg: "周"},
  {id: "month", msg: "月"},
  {id: "year", msg: "年"},
]

export const appFrom = [
  {id: 0, msg: "安装"},
  {id: 1, msg: "系统"},
];

export const deviceInstallStatus = [
  {id: 0, msg: "未知错误"},
  {id: 1, msg: "已安装", color: "color-success"},
  {id: 2, msg: "正在安装", color: "color-warning"},
  {id: 3, msg: "安装失败", color: "color-danger"},
  {id: 4, msg: "下载失败", color: "color-danger"},
  {id: 5, msg: "正在启动", color: "color-warning"},
  {id: 6, msg: "启动失败", color: "color-danger"},
  {id: 7, msg: "正在重置", color: "color-warning"},
  {id: 8, msg: "正在重装", color: "color-warning"},
  {id: 9, msg: "执行失败", color: "color-danger"},
  {id: 10, msg: "正在运行", color: "color-success"},
  {id: 11, msg: "不支持", color: "color-danger"},
  {id: 12, msg: "已过期", color: "color-warning"},
  {id: 13, msg: "已禁用", color: "color-disable"},
  {id: 14, msg: "正在执行"},
];

export const pluginState = [
  {id: false, msg: "禁用", color: "color-danger"},
  {id: true, msg: "启用", color: "color-success"},
];

export const pluginType = [
  {id: "ai", msg: "盟友"},
  {id: "bill", msg: "计费"},
  {id: "audit", msg: "审计"},
  {id: "app", msg: "应用"},
  {id: "tr069_acs", msg: "TR069-ACS"},
];

export const platformType = [
  "MT3052",
  "MT7620",
  "MT7621",
  "MT7628",
  "MT7623",
  "MT7981",
  "MT7986",
  "ralink",
  "qca",
  "athores",
  "x86-64",
  "x86",
  "cavium",
  "cortina",
  "realtek",
  "marvell",
  "rkchip",
];

export const coreType = [
  {id: "4.4.198", msg: "4.4.198"},
];

export const voucherStatus = [
  {id: 0, msg: "未使用", color: "color-disable"},
  {id: 1, msg: "已使用", color: "color-success"},
  {id: 2, msg: "已过期", color: "color-warning"},
  {id: 3, msg: "已禁用", color: "color-danger"},
]

export const orderStatus = [
  {id: 0, msg: "待审核"},
  {id: 1, msg: "审核通过", color: "color-success"},
  {id: 2, msg: "审核不通过", color: "color-danger"},
]

export const shortcuts = [
  {
    text: "一个月",
    onClick(picker) {
      const date = new Date();
      date.setMonth(date.getMonth() + 1);
      picker.$emit('pick', date);
    }
  },
  {
    text: "三个月",
    onClick(picker) {
      const date = new Date();
      date.setMonth(date.getMonth() + 3);
      picker.$emit('pick', date);
    }
  },
  {
    text: "半年",
    onClick(picker) {
      const date = new Date();
      date.setMonth(date.getMonth() + 6);
      picker.$emit('pick', date);
    }
  },
  {
    text: "一年",
    onClick(picker) {
      const date = new Date();
      date.setFullYear(date.getFullYear() + 1);
      picker.$emit('pick', date);
    }
  },
  {
    text: "五年",
    onClick(picker) {
      const date = new Date();
      date.setFullYear(date.getFullYear() + 5);
      picker.$emit('pick', date);
    }
  },
  {
    text: "十年",
    onClick(picker) {
      const date = new Date();
      date.setFullYear(date.getFullYear() + 10);
      picker.$emit('pick', date);
    }
  },
  {
    text: "五十年",
    onClick(picker) {
      const date = new Date();
      date.setFullYear(date.getFullYear() + 50);
      picker.$emit('pick', date);
    }
  }
]